import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer-trustarc',
    templateUrl: './footer-trustarc.component.html',
    styleUrls: ['./footer-trustarc.component.scss']
})
export class FooterTrustarcComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
        setTimeout(() => {
            try {
                window['truste'].eu.icon.initialize();
            }
            catch (e) {
                console.log('TrustArc init error');
            }
        }, 1500);
    } 

}
